<template>
	<div class="pack">
		<ul class="uk-child-width-1-3@s uk-grid-match uk-grid-medium" uk-grid>
			<pack-item v-for="item in items" :item="item" :key="item.id" :currentId="currentItem.id" v-on:changePrice="changePrice"></pack-item>
			<!--<li>
				<div>
					<h3>Текущий выбор:
						<small>{{ currentItem.title }}</small>
					</h3>
					<h3>Цена:
						<small>{{ currentPrice }}</small>
					</h3>
				</div>
			</li>-->
		</ul>
	</div>
</template>

<script>
  import packItem from './pack-item'

  export default {
    name: "pack",
    data() {
      return {
        currentItem: '',
        currentPrice: ''
      }
    },
    props: {
      items: ''
    },
    components: { packItem },
    computed: {
    },
    methods: {
      check(item) {
        this.currentItem = item;
      },
      changePrice(price) {
        this.currentPrice = price;
        this.$emit('changePack', price);
      },
    },
    mounted() {
      this.currentItem = this.items[0];
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// themes/polza/src/js/components/commerce/pack.vue